import script from "./UserTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserTable.vue?vue&type=script&setup=true&lang=ts"

import "@/components/user/UserTable.css?vue&type=style&index=0&id=3ca6ab7c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ca6ab7c"]])

export default __exports__